
import React from 'react';

const AISection: React.FC = () => {
  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-blue-600/5 blur-[120px] rounded-full pointer-events-none" />
      
      <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="order-2 lg:order-1">
          <div className="glass p-1 rounded-3xl border-white/10 overflow-hidden shadow-2xl">
            <div className="bg-[#050505] rounded-[1.4rem] p-8">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-3 h-3 rounded-full bg-red-500 animate-pulse" />
                <div className="w-3 h-3 rounded-full bg-yellow-500 opacity-50" />
                <div className="w-3 h-3 rounded-full bg-green-500 opacity-50" />
                <span className="ml-auto text-[10px] text-gray-500 font-mono">LQP AI Engine v2.5</span>
              </div>
              <div className="space-y-4">
                <div className="p-4 rounded-xl bg-white/5 border border-white/10 text-sm text-blue-400 font-mono">
                  {"> "} Analizando reporte de ventas Q3...
                </div>
                <div className="p-4 rounded-xl bg-white/5 border border-white/10 text-sm text-gray-400">
                  "Se detectó un cuello de botella en el proceso de facturación. Recomiendo automatizar el flujo de proveedores para ahorrar 12h semanales."
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="h-20 glass rounded-xl border-white/5 flex flex-col items-center justify-center">
                    <span className="text-xs text-gray-500 uppercase tracking-widest">Ahorro</span>
                    <span className="text-xl font-bold text-white">40%</span>
                  </div>
                  <div className="h-20 glass rounded-xl border-white/5 flex flex-col items-center justify-center">
                    <span className="text-xs text-gray-500 uppercase tracking-widest">Precisión</span>
                    <span className="text-xl font-bold text-white">99.9%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="inline-block px-4 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-xs font-bold text-blue-400 mb-6">
            INTELIGENCIA ARTIFICIAL APLICADA
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-8 leading-tight">
            IA que entiende <br /> <span className="text-blue-500">tu negocio</span>
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-8">
            Integramos inteligencia artificial para que puedas consultar información, obtener reportes, analizar datos y recibir recomendaciones basadas en tus propios documentos y sistemas.
          </p>
          <ul className="space-y-4">
            {[
              "Consultas en lenguaje natural sobre tus datos",
              "Análisis predictivo de stock y ventas",
              "Recomendaciones inteligentes de optimización",
              "Aprendizaje continuo de tu operación real"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-4 text-gray-300">
                <div className="w-6 h-6 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-400 text-xs font-bold">
                  ✓
                </div>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AISection;
